import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const versionClose = () => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:close`, 
        category: settings.categoryName 
    });
};

export default versionClose;